{
  "aiGeneratedAnswer": "Yapay Zekâ Tarafından Oluşturulan Yanıt",
  "allCategories": "Tüm Kategoriler",
  "appliedFiltersToCurrentSearch": "Mevcut aramaya uygulanan filtreler",
  "apply": "Uygula",
  "applyFilters": "Filtreleri Uygula",
  "autocompleteOptionsFound_one": "{{count}}{{label}} tamamlayıcı seçenek bulundu.",
  "autocompleteOptionsFound_other": "{{count}}{{label}} tamamlayıcı seçenekler bulundu.",
  "autocompleteSuggestion": "tamamlayıcı öneri: {{suggestion}}",
  "autocompleteSuggestionsFound_one": "{{count}} tamamlayıcı öneri bulundu.",
  "autocompleteSuggestionsFound_other": "{{count}} tamamlayıcı öneri bulundu.",
  "basedOnYourDevice": " (cihazınıza göre)",
  "basedOnYourInternetAddress": " (internet adresinize göre)",
  "categoriesText_other": "Aşağıdaki kategoriler için sonuçlar bulundu – <strong>{{query}}</strong>",
  "clearAll": "Tümünü Temizle",
  "clearMinAndMax": "Min ve maks değerleri temizle",
  "clearTheRangeToSelectOptions": "Seçenekleri seçmek için aralığı temizle.",
  "clearTheSearchBar": "Arama çubuğunu temizle",
  "conductASearch": "Arama yap",
  "currentLocation": "Mevcut Konum",
  "didYouMean": "Demek istediniz mi <button>{{correctedQuery}}</button>",
  "dropDownScreenReaderInstructions": "Tamamlayıcı sonuçlar mevcut olduğunda, yukarı/aşağı okları kullanarak gezinip enter ile seçin.",
  "feedback": "Geri bildirim",
  "filterGroupSearchInputLabel": "{{title}} seçeneklerinde ara",
  "invalidRange": "Geçersiz aralık",
  "max": "Maks",
  "min": "Min",
  "navigateToTheNextResultsPage": "Sonraki sonuç sayfasına git",
  "navigateToThePreviousResultsPage": "Önceki sonuç sayfasına git",
  "noAutocompleteOptionsFound": "0 tamamlayıcı seçenek bulundu.",
  "noAutocompleteSuggestionsFound": "0 tamamlayıcı öneri bulundu.",
  "noResultsFoundIn": "{{currentVerticalLabel}} içinde sonuç bulunamadı.",
  "paginationPage": "sayfa {{pageNumber}}",
  "pagination": "Sayfalandırma",
  "readMoreAbout": "<a>{{name}}</a> hakkında daha fazla oku",
  "recentSearch": "son arama: {{query}}",
  "recentSearchesFound_one": "{{count}} son arama bulundu.",
  "recentSearchesFound_other": "{{count}} son arama bulundu.",
  "removeFilter": "“{{displayName}}” filtresini kaldır",
  "resultPreview": "sonuç önizlemesi: {{value}}",
  "resultPreviewsFound_one": "{{count}} sonuç önizlemesi bulundu.",
  "resultPreviewsFound_other": "{{count}} yakın zamanda önizleme bulundu.",
  "resultsCountText_one": "{{count}} Sonuç",
  "resultsCountText_other": "{{count}} Sonuç",
  "resultsCountWithPaginationText": "{{paginateStart}} - {{paginateEnd}} toplam {{resultsCount}} sonuç",
  "searchHere": "Burada ara…",
  "showingAllInstead": "Bunun yerine tüm {{currentVerticalLabel}} gösteriliyor.",
  "showLess": "Daha az göster",
  "showMore": "Daha fazla göster",
  "sources_one": "Kaynak",
  "sources_other": "Kaynaklar ({{count}})",
  "submitSearch": "Aramayı Gönder",
  "suggestionResultsCount_one": "{{label}} - {{count}} sonuç",
  "suggestionResultsCount_other": "{{label}} - {{count}} sonuç",
  "thankYouForYourFeedback": "Geri bildiriminiz için teşekkürler!",
  "thisAnsweredMyQuestion": "Bu sorumu yanıtladı",
  "thisDidNotAnswerMyQuestion": "Bu sorumu yanıtlamadı",
  "unselectAnOptionToEnterInARange": "Aralık girmek için bir seçeneğin seçimini kaldırın.",
  "updateYourLocation": "Konumunuzu güncelleyin",
  "useCurrentLocation": "Mevcut Konumu Kullan",
  "useMyLocation": "Konumumu kullan",
  "viewAll": "Tümünü Gör",
  "viewDetails": "Detayları Görüntüle"
}
